import React from "react";

const Footer: React.FC = () => (
  <footer
    className="bg-light text-center text-lg-start mt-5 border-top pt-3 pb-2"
    style={{ fontSize: 15 }}
  >
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-4 text-md-start text-center mb-2 mb-md-0">
          <strong>Kết nối với Tuyển dụng 4handy</strong>
          <br />
          <a
            href="https://www.facebook.com/tuyendung4handy"
            target="_blank"
            rel="noopener noreferrer"
            className="mx-2"
          >
            <span role="img" aria-label="Facebook">
              📘
            </span>{" "}
            Fanpage Tuyển dụng 4handy
          </a>
          <br />
          <a
            href="https://www.facebook.com/tuyendungsavor"
            target="_blank"
            rel="noopener noreferrer"
            className="mx-2"
          >
            <span role="img" aria-label="Facebook">
              📘
            </span>{" "}
            Fanpage Tuyển dụng Savor
          </a>
          <br />
          <a
            href="https://www.tiktok.com/@tuyendungabbysavor"
            target="_blank"
            rel="noopener noreferrer"
            className="mx-2"
          >
            <span role="img" aria-label="TikTok">
              🎵
            </span>{" "}
            TikTok
          </a>
          <br />
          <a
            href="https://www.threads.com/@4handycareer"
            target="_blank"
            rel="noopener noreferrer"
            className="mx-2"
          >
            <span role="img" aria-label="Threads">
              #️⃣
            </span>{" "}
            Thread
          </a>
        </div>
        <div className="col-md-8 text-md-end text-center">
          <div>
            <strong>Thông tin liên hệ</strong>
            <br />
            Hotline: <a href="tel:0974932066">0974 932 066</a> / Zalo:{" "}
            <a href="tel:0399063889">0399 063 889</a>
            <br />
            Email:{" "}
            <a href="mailto:tuyendung@4-handy.com">tuyendung@4-handy.com</a>
          </div>
          <div className="mt-2">
            &copy; {new Date().getFullYear()} 4Handy Group JSC. All rights
            reserved.
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
